import useFirestoreWatch from '@onepercentio/one-ui/hooks/useFirestoreWatch'
import { watchCVMForm } from 'core/modules/firebase/service'
import { ComponentProps, useMemo } from 'react'
import FormLogic from './Form/Form.logic'
import { useUser } from 'core/logic/user'
import { RarumUserProfile } from 'core/logic/user/user.types'
import { ALL_POSSIBLE_ANSWERS } from 'features/FlowPrerequirements/StandalonePrereq/StandalonePrereq.types'

function hasAllRequiredDocs(documents: any[]) {
  /** FormStep.ADDITIONAL_DATA, FormStep.PERSONAL_DATA, FormStep.DOCUMENTS, FormStep.INVEST_PROFILE */
  return documents.length === 4
}

export function useAnswers(forceUpdate: boolean = false) {
  const { profile } = useUser()
  const documents = useFirestoreWatch(watchCVMForm, [])
  const savedAnswers = useMemo(() => {
    return documents?.reduce((r, { id, ...document }) => {
      return {
        ...r,
        ...document,
      }
    }, {} as ComponentProps<typeof FormLogic>['savedAnswers'])
  }, [!forceUpdate ? !!documents : documents])

  const cvm88Status = useMemo(() => {
    if (!documents) return
    if (profile?.cvm88Status === 'rejected') return 'rejected' as const
    else if (
      hasAllRequiredDocs(documents) &&
      documents.reduce((r, doc) => r && doc.status === 'approved', true)
    )
      return 'approved'
    else if (
      hasAllRequiredDocs(documents) &&
      documents.reduce((r, doc) => r && doc.status === 'pending', true)
    )
      return 'pending' as const
    else return 'incomplete' as const
  }, [documents, profile?.cvm88Status])

  const sentToReview = useMemo(() => {
    if (!documents || !hasAllRequiredDocs(documents)) return false
    const someDocMissingStatus = documents.find((a) => a.status === undefined)
    return !someDocMissingStatus
  }, [documents])

  console.log("hook", cvm88Status)

  return {
    savedAnswers,
    cvm88Status: cvm88Status as RarumUserProfile['cvm88Status'] | 'incomplete',
    sentToReview,
  }
}

export function useFormPreffilFromCVM() {
  const cvm = useAnswers()
  return useMemo(() => {
    if (!cvm.savedAnswers) return
    return {
      document: cvm.savedAnswers?.cpf,
      phone: cvm.savedAnswers?.phone as any,
      address: cvm.savedAnswers?.address as any,
      birthDate: cvm.savedAnswers?.birthdate,
      name:
        cvm.savedAnswers?.name && cvm.savedAnswers?.surname
          ? `${cvm.savedAnswers?.name} ${cvm.savedAnswers?.surname}`
          : undefined,
    } satisfies ALL_POSSIBLE_ANSWERS
  }, [cvm.savedAnswers])
}
